<template>
  <CTabs variant="tabs" class="nav-tabs-boxed">
    <CTab title="Prioridades de Pedido">
      <crud-base
        :url="url"
        :columns="columns"
        :onDelete="() => {}"
        :onUpdate="() => {}"
        :onStore="() => {}"
        :enableSearch="true"
        :checkAlerts="true"
        :formInputs="formInputs"
        primaryKey="id"
      >
        <template v-slot:cor="{ model }">
          <span
            v-if="model.cor"
            :style="{
              display: 'inline-block',
              width: '20px',
              height: '20px',
              borderRadius: '4px',
              background: model.cor,
              border: '1px solid #ccc',
            }"
          ></span>
        </template>
      </crud-base>
    </CTab>
  </CTabs>
</template>

<script>
import CrudBase from "../../components/crud/CrudBase";
import {
  schemaTextField,
  schemaBooleanSelect,
  schemaNumber,
  schemaColorPicker,
} from "@/helpers/form";
import { yesNoRepresentation } from "@/helpers/transformers";

export default {
  name: "PedidoPrioridade",
  components: {
    CrudBase,
  },
  data() {
    return {
      url: "/admin/pedido-prioridade",
      columns: [
        { label: "ID", field: "id", sortable: false },
        { label: "DESCRIÇÃO", field: "descricao", sortable: false },
        { label: "COR", field: "cor", sortable: false, useSlot: true },
        { label: "ORDEM", field: "ordem", sortable: false },
        {
          label: "% FINANCEIRO",
          field: "percentual_financeiro",
          sortable: false,
        },
        { label: "TAXA FIXA", field: "taxa_fixa", sortable: false },
        { label: "VALOR MÍNIMO", field: "valor_minimo", sortable: false },
        {
          label: "ATIVO",
          field: "ativo",
          sortable: false,
          representedAs: (row) => yesNoRepresentation(row.ativo),
        },
      ],
      formInputs: {
        id: schemaTextField("Cód.", true, 3),
        descricao: schemaTextField("Descrição", true, 5),
        ordem: schemaNumber("Ordem", false, 2, 1),
        percentual_financeiro: schemaNumber("% Financeiro", false, 4),
        taxa_fixa: schemaNumber("Taxa Fixa", false, 4),
        valor_minimo: schemaNumber("Valor Mínimo", false, 4),
        ativo: schemaBooleanSelect("Ativo", true, 2, 1, 1),
        cor: schemaColorPicker("Cor", false, 12),
      },
    };
  },
};
</script>
